import {
  getAge,
  getAlertMessageFunction,
  getCurrentYear,
  isCheckHouseHolder,
} from '../../common/Util';

// 공제불가항목 필터
export const filterNonDependentList = (list, htm013) => {
  const nonDependentList = [];

  list.forEach((item, index) => {
    // 성별 및 외국인 플래그 초기화
    let sexFlag = '0',
      oldNum = '0',
      fFlag = '1';
    let age = 0;

    const { htm001, htm002, htmYy, htm159 } = item;

    if (htm001.trim().length === 13) {
      sexFlag = htm001.substring(6, 7);
      oldNum = htm001.substring(0, 2);
      const birthday = htm001.substring(0, 6);
      age = getAge(birthday, sexFlag, htmYy);
      fFlag = ['5', '6', '7', '8'].includes(sexFlag) ? '9' : '1';
      sexFlag = ['1', '3', '5', '7'].includes(sexFlag) ? '1' : '2';

      if (Number(htm013) > 41470588 || sexFlag !== '2') {
        // 부녀자 조건 추가
        if (!nonDependentList[index]) nonDependentList[index] = [];
        nonDependentList[index].push('htm005');
      }
    }

    //소득금액 100만원 이상인사람 소득공제, 기본공제 체크못하게 수정
    if (!nonDependentList[index]) nonDependentList[index] = [];

    if (htm159 == '1') {
      nonDependentList[index].push('htm074');
      nonDependentList[index].push('htm003');
    }

    // 본인 처리
    if (htm002 === '0') {
      nonDependentList[index] = nonDependentList[index] || [];
      nonDependentList[index].push('htm074');

      if (isCheckHouseHolder(htm001)) {
        // 세대주
        nonDependentList[index].push('htm040');
      }

      if (age !== 0) {
        // 출생
        nonDependentList[index].push('htm008');
      }

      // 입양
      nonDependentList[index].push('htm058');

      if (age < 70) {
        // 경로우대
        nonDependentList[index].push('htm039');
      }

      if (fFlag !== '9') {
        // 외국인
        nonDependentList[index].push('htm032');
      }
    } else {
      // 본인 외 처리
      nonDependentList[index] = nonDependentList[index] || [];
      // 세대주, 한부모, 부녀자, 결혼세액공제
      nonDependentList[index].push('htm040', 'htm013', 'htm080', 'htm005', 'htm158');

      if (['1', '2', '3', '5', '6'].includes(htm002)) {
        nonDependentList[index].push('htm008', 'htm058');
      }

      if (age < 70) {
        nonDependentList[index].push('htm039');
      }

      if (age !== 0) {
        nonDependentList[index].push('htm008');
      }

      if (age >= 20) {
        nonDependentList[index].push('htm058');
      }

      if (fFlag !== '9') {
        nonDependentList[index].push('htm032');
      }
    }
  });

  return nonDependentList;
};

//유효성 체크
export const checkValidity = (dataList, index, key, value, t, parentKey) => {
  const alertMessage = getAlertMessageFunction();
  let {
    htm038,
    htm002,
    htm003,
    htm004,
    htm039,
    htm074,
    htm005,
    htm080,
    htm036,
    htm008,
    htm058,
    htm109,
    htm081,
  } = dataList[index];

  // key에 해당하는 값을 value로 업데이트
  if (key == 'htm003') htm003 = value;
  if (key == 'htm004') htm004 = value;
  if (key == 'htm039') htm039 = value;
  if (key == 'htm074') htm074 = value;
  if (key == 'htm080') htm080 = value;
  if (key == 'htm002') htm002 = value;
  if (key == 'htm036') htm036 = value;
  if (key == 'htm008') htm008 = value;
  if (key == 'htm058') htm058 = value;
  if (key == 'htm109') htm109 = value;
  if (key == 'htm005') htm005 = value;
  if (key == 'htm081') htm081 = value;
  let age = 0;
  console.log('index >>', index);
  //한부모 유/무
  if (htm080 == '1') {
    // 배우자 체크
    if (dataList.some(item => item.htm002 == '3')) {
      alertMessage(`[${dataList[index].htm038}] ${t('alertMessage.message4')}`);
      return false;
    }

    // 직계비속 중 기본공제 대상자가 있는지 확인
    const hasValidDescendant = dataList.some(item => item.htm002 == '4' && item.htm003 == '1');

    //기본공제대상 직계비속이 없는 경우 한부모 해당사항이 없습니다.
    if (!hasValidDescendant) {
      alertMessage(`[${dataList[index].htm038}] ${t('alertMessage.message5')}`);
      return false;
    }

    if (htm005 == '1') {
      //부녀자 공제와 한부모 공제는 중복 적용할 수 없습니다. 한부모 공제를 선택하시려면 부녀자 공제를 먼저 해제해 주세요.
      alertMessage(`[${dataList[index].htm038}] ${t('alertMessage.message27')}`);
      return false;
    }
  }

  if (htm005 == '1') {
    if (htm080 == '1') {
      //부녀자 공제와 한부모 공제는 중복 적용할 수 없습니다. 부녀자 공제를 선택하시려면 한부모 공제를 먼저 해제해 주세요.
      alertMessage(`[${dataList[index].htm038}] ${t('alertMessage.message28')}`);
      return false;
    }
  }

  let sexFlag = dataList[index].htm001.substring(6, 7);
  const birthday = dataList[index].htm001.substring(0, 6);

  age = getAge(birthday, sexFlag, dataList[index].htmYy);

  console.log('age >>', age);

  //본인은 체크 X
  if (htm002 != '0') {
    if (htm074 != '1' && htm003 == '1') {
      //소득 100 안넘으면 기본 X
      alertMessage(`[${htm038}] ${t('alertMessage.message1')}`);
      return false;
    }
  }

  if (htm002 == '6' && age > 20) {
    //만 20세 안넘으면 위탁 X
    alertMessage(`[${htm038}] ${t('alertMessage.message2')}`);
    return false;
  }

  if (htm039 == '1' && age < 70) {
    //경로우대는 70세 이상
    alertMessage(`[${htm038}] ${t('alertMessage.message3')}`);
    return false;
  }

  //사위 며느리는 장애인만 선택가능
  if ((htm036 == '3' || htm036 == '4') && key != 'htm081') {
    if (htm004 != '1') {
      alertMessage(`[${htm038}] ${t('alertMessage.message6')}`);
      return false;
    }
  }

  //기본공제 대상자가 아닌데
  if (htm003 != '1') {
    //출생 공제 체크
    if (htm008 == '1') {
      //출생공제는 기본공제자만 가능합니다.
      alertMessage(`[${htm038}] ${t('alertMessage.message20')}`);
      return false;
    }

    //입양공제체크
    if (htm058 == '1') {
      //입양공제는 기본공제자만 가능합니다.
      alertMessage(`[${htm038}] ${t('alertMessage.message21')}`);
      return false;
    }

    if (htm109 > '0') {
      //자녀공제는 기본공제자만 가능합니다.
      alertMessage(`[${htm038}] ${t('alertMessage.message22')}`);
      return false;
    }
    // //장애인 체크 (사위, 며느리는 장애인이 체크되어야 함)
    // 연말정산팀 요청으로 추가했으나, 장애인일 때 기본공제는 연령조건 받지않기때문에 다시 삭제함 25.12.29 선희
    // if ((htm004 == '1' || htm081 > '0') && htm036 != '3' && htm036 != '4') {
    //   //장애인 공제는 기본공제자만 가능합니다.
    //   alertMessage(`[${htm038}] ${t('alertMessage.message25')}`);
    //   return false;
    // }
  }

  if (
    key == 'htm109' &&
    ((parentKey == 'htm008' && htm058 == '1') || (parentKey == 'htm058' && htm008 == '1'))
  ) {
    // 출생과 입양은 같이 선택할 수 없습니다.
    alertMessage(`[${htm038}] ${t('alertMessage.message23')}`);
    return false;
  }

  //기본공제 대상자인데 체크안한 경우
  if (htm003 != '1') {
    if (htm039 == '1') {
      //경로우대 대상자가 되려면 기본공제 체크해야함
      alertMessage(`[${htm038}] ${t('alertMessage.message7')}`);
      return false;
    }

    if (htm002 != '0' && htm002 != '3' && age <= 20) {
      //20세이하는 기본공제 대상자일 수 있음
      alertMessage(`[${htm038}] ${t('alertMessage.message8')}`);
    }

    if (htm002 != '0' && htm002 != '3' && age >= 60) {
      //60세이상은 기본공제 대상자일 수 있음
      alertMessage(`[${htm038}] ${t('alertMessage.message9')}`);
    }
  }

  //기본공제 대상자가 아닌데 공제대상 체크한 경우
  if (htm003 == '1') {
    //장애인이 아닌데
    if (htm004 != '1') {
      if (htm002 != '0' && htm002 != '3' && age > 20 && age < 60) {
        alertMessage(`[${htm038}] ${t('alertMessage.message10')}`);
        return false;
      }

      //기본공제이면서 70세 이상은 경로우대임
      if (age >= 70 && htm039 != '1' && htm002 != '0') {
        alertMessage(`[${htm038}] ${t('alertMessage.message11')}`);
      }
    }
  }

  return true;
};

export const checkFormData = (data, alertMessage, t, dataList, setIsSlideDialogV) => {
  let { htm001, htm002, htm002_old, htm036, htm038 } = data;
  htm001 = htm001.replace(/-/g, '');
  console.log('htm001 >>', htm001);
  let sexFlag = htm001.substring(6, 7);
  let me = dataList.find(item => item.htm002 == '0');
  let meSexFlag = me.htm001.substring(6, 7);
  let meAge = getAge(me.htm001.substring(0, 6), meSexFlag, getCurrentYear());

  const birthday = htm001.substring(0, 6);
  let age = getAge(birthday, sexFlag, getCurrentYear());

  //1 남자 2 여자
  let isMale = sexFlag == '1' || sexFlag == '3' || sexFlag == '5' || sexFlag == '7' ? '1' : '2';
  let isHtm001Male =
    meSexFlag == '1' || meSexFlag == '3' || meSexFlag == '5' || meSexFlag == '7' ? '1' : '2';
  //배우자 유무 (수정하려는 사람이 기존에 배우자였던 경우는 제외)
  const isWife = dataList.some(item => item.htm002 == '3' && htm002_old !== '3');
  //본인의 성별

  console.log('isMale>>', isMale);
  console.log('isHtm001Male>>', isHtm001Male);

  if (htm001.length !== 13) {
    // 주민등록번호를 확인해주세요.
    alertMessage(t('alertMessage.message14'));
    return;
  }

  // 생년월일 유효성 체크
  if (birthday.length === 6) {
    const month = parseInt(birthday.substring(2, 4), 10);
    const day = parseInt(birthday.substring(4, 6), 10);

    // 월 유효성 체크 (1~12월)
    if (month < 1 || month > 12) {
      alertMessage(t('alertMessage.message26'));
      return;
    }

    // 각 월별 최대 일수
    const daysInMonth = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    const maxDay = daysInMonth[month - 1];

    // 일 유효성 체크
    if (day < 1 || day > maxDay) {
      alertMessage(t('alertMessage.message26'));
      return;
    }
  }

  if (htm038.trim() === '') {
    // 이름을 입력해주세요
    alertMessage(t('alertMessage.message15'));
    return;
  }

  if (htm002.trim() === '') {
    // 관계를 선택해주세요.
    alertMessage(t('alertMessage.message12'));
    return;
  }
  if (htm002 === '4' && htm036.trim() === '') {
    // 직계비속을 분류를 선택해주세요.
    alertMessage(t('alertMessage.message13'));
    return;
  }

  if (htm002 === '6' && age > 20) {
    // 만 20세가 넘으면 위탁아동으로 설정 할 수 없습니다.
    alertMessage(t('alertMessage.message16'));
    return;
  }

  if (htm002 == '3' && isMale == isHtm001Male) {
    //배우자 주민번호 오류로 인적공제자 관계 확인 바랍니다.
    alertMessage(t('alertMessage.message17'));
    return;
  }

  if (isWife && htm002 === '3') {
    // 배우자가 이미 등록되었습니다.
    alertMessage(t('alertMessage.message19'));
    return;
  }

  //년 이후 출생자는 등록할 수 없습니다.
  if (age < 0) {
    alertMessage(Number(getCurrentYear()) + 1 + t('alertMessage.message18'));
    return;
  }

  //소득자 직계존속, 배우자 직계존속
  if ((htm002 == '1' || htm002 == '2') && meAge > age) {
    //직계존속이 본인보다 나이가 적습니다~~
    setIsSlideDialogV('2');
    return;
  }

  //소득자 직계존속, 배우자 직계존속
  if (htm002 == '4' && meAge < age) {
    //직계비속이 본인보다 나이가 많습니다.~~
    setIsSlideDialogV('1');
    return;
  }

  return true;
};
